// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChartRendererController from "./chart_renderer_controller"
import ChartStateController from "./chart_state_controller"
import CopyLinkController from "./copy_link_controller"
import InlineTitleController from "./inline_title_controller"
import NotificationController from "./notification_controller"
import PanelSwitcherController from "./panel_switcher_controller"

application.register("chart-renderer", ChartRendererController)
application.register("chart-state", ChartStateController)
application.register("copy-link", CopyLinkController)
application.register("inline-title", InlineTitleController)
application.register("notification", NotificationController)
application.register("panel-switcher", PanelSwitcherController)
